<template>
  <div>
    <div class="handle-line mb20">
      <div>
        <span class="select-label">类型</span>
        <el-select
          class="ml10 my-select mr20"
          v-model="historyAnalysisKeyType"
          filterable
          placeholder="请选择类型"
        >
          <el-option
            v-for="(v, i) in typeOptions"
            :key="i"
            :label="v.label"
            :value="v.value"
          />
        </el-select>
      </div>
      <div class="mt10 line">
        <span class="select-label">时间</span>
        <el-radio-group
          v-model="historyAnalysisTimeType"
          class="ml10"
          change="changeBarType"
        >
          <el-radio :label="1">日</el-radio>
          <el-radio :label="2">周</el-radio>
          <el-radio :label="3">月</el-radio>
          <el-radio :label="4">季</el-radio>
          <el-radio :label="5">年</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="foot-btn">
      <el-button
        type="primary"
        @click="submit"
      >确 定</el-button>
    </div>
    <model-login-detail
      title="登录"
      width="25%"
      ref="modelLoginDetailRef"
    />
  </div>
</template>

<script>
import { api } from '@/api/api'
import ModelLoginDetail from './ModelLoginDetail.vue'
// import LineBarChart from '../echartComponents/LineBarChart.vue'
export default {
  components: { ModelLoginDetail },
  data() {
    return {
      historyAnalysisKeyType: 1,
      historyAnalysisTimeType: 1,
      barDateRange: [],
      lineDateRange: [],
      typeOptions: [{
        label: '机组效率',
        value: 1
      }, {
        label: '耗水率',
        value: 2
      }, {
        label: 'F值',
        value: 3
      }, {
        label: '有功功率',
        value: 4
      }, {
        label: '无功功率',
        value: 5
      }, {
        label: '工作水头',
        value: 6
      }]
    }
  },
  mounted() {

  },
  methods: {
    submit() {
      let params = {
        url: api.updateSetting,
        data: {
          id: 1,
          historyAnalysisKeyType: this.historyAnalysisKeyType,
          historyAnalysisTimeType: this.historyAnalysisTimeType
        },
        token: localStorage.getItem('token')
      }
      this.$http.put(params).then((res) => {
        if(res.data.code == 200) {
          this.$emit('getParams', params.data)
        }else if(res.data.code == 500) {
          this.$message.error(res.data.msg)
        }else {
          this.$message.error('连接超时')
          this.$refs.modelLoginDetailRef.show()
        }
      })
    },
    getData() {
      this.$http.get({ url: api.getSetting }).then(res => {
        this.historyAnalysisKeyType = res.data.data.historyAnalysisKeyType
        this.historyAnalysisTimeType = res.data.data.historyAnalysisTimeType
      })
    }
  },
}
</script>

<style scoped>
.handle-line /deep/ .el-radio__label {
  color: #fff !important;
}
.handle-line /deep/ .el-input--mini .el-input__inner {
  background: #0c2341 !important;
  border: 1px solid #1a4c89 !important;
  color: #fff !important;
}
.handle-line .data-picker {
  width: 230px !important;
  background-color: #0c2342 !important;
  border: 1px solid #1a4c89 !important;
}
.handle-line .my-select {
  width: 130px !important;
  background-color: #0c2342 !important;
}
.handle-line /deep/ .el-range-editor--mini .el-range-input {
  background: #0c2341 !important;
  color: #fff;
}
.handle-line .date-picker {
  width: 230px !important;
  background-color: #0c2342 !important;
  border: 1px solid #1a4c89 !important;
}
</style>

<style scoped lang="scss">
.handle-line {
  .select-label {
    color: #fff;
    font-size: 14px;
    margin-left: 20px;
    line-height: 28px;
  }
}
.content {
  .echart-box {
    height: 200px;
    width: 100%;
  }
}
.foot-btn {
  text-align: end;
  margin-bottom: -30px;
}
</style>